export const ROUTE_PATHS = {
    ROOT: '/',
    EMPTY: '',
    MATCH_ALL: '*',
    NEW: 'new',
    EDIT: 'edit',
    BULK: 'bulk',
    VIEW: 'view',
    ID: ':id',
    CP: 'cp',
    NOTIFICATIONS: 'notifications',
    SHARE: 'share',
    CREATE: 'create',
    EMBED: 'embed',
    TWO_FA: '2fa',
    IMPLICIT: 'implicit',
    CALLBACK: 'callback',
    FIELD_ID: ':fieldId',
    TASK_ID: ':taskId',
    WEBHOOK_ID: ':webhookId',
    DASHBOARD_ID: ':dashboardId',
    DASHBOARD_WIDGETS_ID: ':widgetId',
    INVOICE_ID: ':invoiceId',
    TEAM_MEMBERS: 'team-members',
    MAGIC_LINK: 'magiclink',
    LOGIN: 'login',
    LOGOUT: 'logout',
    GOODBYE: 'goodbye',
    SETUP_PROFILE: 'setup-profile',
    FORGOT_PASSWORD: 'forgot-password',
    RESET_PASSWORD: 'set-password',
    LINK_ACTION: 'link-action',
    ACTIVATE: 'activate',
    LOGIN_SESSION: 'login-session',
    ATTACHMENTS: 'attachments',
    ATTACHMENT_ID: ':attachmentId',
    SIDE_BY_SIDE: 'sidebyside',
    OVERLAY: 'overlay',
    COMPARE_ATTACHMENT_ID: ':compareAttachmentId',
    WORKSPACE: 'workspace',
    RESPONSIVE: 'responsive',
    PROJECT_UPDATE_RESPONSIVE: 'project-update-responsive',
    RESPONSIVE_TASK_DESCRIPTION: 'responsive-task-desc',
    TASK_DETAILS: 'taskDetails',
    CUSTOM_AUTOMATION_LOGS: 'custom-automation-logs',
    AUTOMATION: 'automation',
    FEATURE_FLAGS: 'feature-flags',
    OZONE_DESIGN: 'ozone-design',
    COMPANY_TASKS: 'company-tasks',
    DASHBOARDS: 'dashboards',
    SPRINTS: 'sprints',
    EPICS: 'epics',
    EPIC_DETAILS: ':epicId',
    BACKLOG_DETAILS: ':backlogId',
    ADD_TASKS_IN_EPIC: 'add-tasks',
    ADD_TASKS_IN_BACKLOG: 'add-tasks',
    BACKLOG: 'backlog',
    SPRINT_PLANNING: 'sprint-planning',
    DASHBOARD_WIDGETS: 'widgets',
    NEW_DASHBOARD_WIDGET: 'new',
    EDIT_DASHBOARD_WIDGET: 'edit',
    REPORTS: 'reports',
    CSAT_REPORT: 'csat',
    TIMESHEET_REPORT: 'timesheets',
    PROJECTS_REPORT: 'projects',
    SPRINTS_REPORT: 'sprints',
    USERS_REPORT: 'users',
    TEMPLATE_INSIGHT: 'operation',
    INTERVALS_REPORT: 'intervals',
    UTILIZATION_REPORT: 'utilization',
    TIME_ANALYTICS: 'time-analytics',
    TIMESHEET_SUBMISSION_REPORT: 'timesheet-submission',
    CATEGORY_TIME_ANALYTICS_REPORT: 'category-time-analytics',
    PROJECT_TIME_ANALYTICS_REPORT: 'project-time-analytics',
    USER_TIME_ANALYTICS_REPORT: 'user-time-analytics',
    PORTFOLIO_REPORT: 'portfolio',
    CUSTOM_REPORT: 'custom-report/:customReportType/:customReportId',
    ACCOUNTS: 'accounts',
    PROJECTS: 'projects',
    PROJECT_CREATE: 'create',
    PROJECT_CREATE_V2: 'create-v2',
    PROJECT_ID: ':projectId',
    PROJECT_OVERVIEW: 'overview',
    ASK_AI: 'ask-ai',
    PROJECT_FINANCIALS: 'financials',
    PROJECT_PLAN: 'plan',
    PROJECT_TIMELINE: 'timeline',
    PROJECT_SPACES: 'spaces',
    PROJECT_SPACE_ID: ':spaceId',
    PROJECT_SPACE_TAB_ID: ':spaceTabId',
    PROJECT_SPACE_TAB_WITH_SPACE_ID: 'tabs/:spaceTabId',
    PROJECT_CHAT: 'chat',
    PROJECT_CHAT_ID: ':chatId',
    PROJECT_CHAT_ENTITY_TYPE: ':entityType',
    PROJECT_TASKS: 'tasks',
    PROJECT_TASKS_LIST: 'list',
    PROJECT_TASKS_BOARD: 'board',
    PROJECT_STATUS_UPDATES: 'status-updates',
    PROJECT_STATUS_UPDATE_ID: ':statusUpdateId',
    PROJECT_FORMS: 'forms',
    FORM_PREVIEW: 'form-preview',
    PROJECT_FORM_RESPONSES: 'responses',
    PROJECT_FORM_RESPONSE_INSTANCE_ID: ':instanceId',
    PROJECT_FILES: 'files',
    PROJECT_CUSTOMER_PORTAL_CONFIGURATION: 'customer-portal-configuration',
    PROJECT_TIMESHEET: 'timesheet',
    PROJECT_INVOICES: 'invoices',
    PROJECT_INVOICES_DETAIL: 'invoices-detail',
    PROJECT_EXPENSE: 'expense',
    PROJECT_EXPENSE_REPORT: 'expense-report',
    PROJECT_REVENUE_ENTRIES: 'revenue-entries',
    PROJECT_NITRO_PAGES: 'nitro-pages',
    PROJECT_NITRO_PAGE_ID: ':nitroPageId',
    PROJECT_EMAIL_PAGES: 'email-pages',
    PROJECT_EMAIL_PAGE_ID: ':emailPageId',
    PROJECT_EMAILS: 'emails',
    PROJECT_EMAIL_MESSAGE: 'emails/:emailPageId',
    PROJECT_MEETING_PAGES: 'meeting-pages',
    PROJECT_MEETING_PAGE_ID: ':meetingPageId',
    PROJECT_SIGNALS_V2: 'signals',
    PROJECT_SETTINGS: 'settings',
    PROJECT_SETTINGS_DETAILS: 'details',
    PROJECT_SETTINGS_VISIBILITY: 'visibility',
    PROJECT_SETTINGS_MEMBERS: 'members',
    PROJECT_SETTINGS_FINANCIALS: 'financials',
    PROJECT_SETTINGS_DEFAULT_CONFIGURATION: 'default-configuration',
    PROJECT_BUDGET_MANAGEMENT: 'budget-management',
    PROJECT_BUDGET_ID: ':budgetId',
    PROJECT_EXPENSE_BUDGETS: 'expense-budgets',
    PROJECT_EXPENSE_BUDGET_ID: ':expenseBudgetId',
    PROJECT_EXPENSE_BUDGET_AUDIT_LOGS: 'audit-logs',
    PROJECT_SETTINGS_SLACK_NOTIFICATIONS: 'slack-notifications',
    PROJECT_SETTINGS_VAULT: 'vault',
    PROJECT_SETTINGS_WORKFORCE_AGENT: 'workforce-agent',
    PROJECT_RATE_CARDS: 'rate-cards',
    BILLING_EVENT: 'billing-event',
    BILLING_EVENT_ID: ':billingEventId',
    IMPORT_TEMPLATE: 'import-template',
    BILLING_SCHEDULE: 'billing-schedule',
    BILLING_SCHEDULE_TEMPLATE: 'billing-schedule-template',
    AUTOMATIONS: 'automations',
    AUTOMATION_ID: ':automationId',
    AUTOMATION_LOGS: 'logs',
    ALL_TASKS: 'tasks',
    SPRINT_DETAILS: ':sprintId',
    ADD_TASKS_IN_SPRINT: 'add-tasks',
    CREATE_SPRINT: 'create',
    CREATE_EPIC: 'create',
    CREATE_BACKLOG: 'create',
    EDIT_BACKLOG: ':backlogId/edit',
    RESOURCE_MANAGEMENT: 'resource-management',
    PROJECT_RESOURCE_MANAGEMENT: 'resource-management',
    TIMESHEETS: 'timesheets',
    TEMPLATES: 'templates',
    TEMPLATE_ID: ':templateId',
    PROJECT_TEMPLATES: 'projects',
    DOCUMENT_TEMPLATES: 'documents',
    STATUS_UPDATE_TEMPLATES: 'status-updates',
    FORM_TEMPLATES: 'forms',
    FORM_TEMPLATE_ID: ':formTemplateId',
    SAVED_AUTOMATIONS: 'saved-automations',
    LIVE_CUSTOMER_PORTAL_PREVIEW: 'live-customer-portal-preview',
    CUSTOMER_PORTALS: 'customer-portals',
    CUSTOMER_PORTAL_BY_ID: ':id',
    AIFILL_TEMPLATES: 'ai-fill-templates',
    COMPANY_PAGES: 'company-pages',
    COMPANY_PAGE_ID: ':companyPageTemplateId',
    MEETING_PAGES: 'meeting-templates',
    MEETING_PAGE_ID: ':meetingPageTemplateId',
    EMAIL_PAGES: 'email-templates',
    EMAIL_PAGE_ID: ':emailPageTemplateId',
    SHEET_TEMPLATE: 'sheet',
    NEW_SHEET_TEMPLATE: '/templates/sheet/:id',
    SHEET_TEMPLATE_OVERVIEW: '/templates/sheet/:id/overview',
    NEW_SHEET_TEMPLATE_CARD: 'overview/widgets/new-card',
    NEW_SHEET_TEMPLATE_CHART: 'overview/widgets/new-chart',
    NEW_SHEET_TEMPLATE_PIVOT: 'overview/widgets/new-pivot',
    NEW_SHEET_TEMPLATE_SECTION: 'overview/widgets/new-section',
    EDIT_SHEET_TEMPLATE_CARD: 'overview/widgets/:widgetId/edit-card',
    EDIT_SHEET_TEMPLATE_CHART: 'overview/widgets/:widgetId/edit-chart',
    SHEET_TEMPLATE_AUTOMATION_DRAWER: '/templates/sheet/:id/automations',
    TEMPLATE_SHEET_FIELDS: '/templates/sheet/:id/fields',
    SETTINGS: 'settings',
    SETTINGS_PROFILE: 'profile',
    SETTINGS_NOTIFICATIONS: 'notifications',
    SETTINGS_ORGANISATION: 'organisation',
    SETTINGS_EMBED_CUSTOMER_PORTAL: 'embed-customer-portal',
    SETTINGS_CUSTOMER_PORTAL_THEMES: 'customer-portal-themes',
    SETTINGS_CUSTOMER_PORTAL_THEME_ID: ':themeId',
    SETTINGS_CUSTOMER_PORTAL_CONFIG: 'customer-config',
    SETTINGS_CUSTOMER_PORTAL_NOTIFICATIONS: 'notification',
    SETTINGS_CUSTOMER_PORTAL_OLD: 'old-customer-portal',
    SETTINGS_CUSTOMER_PORTAL_INVITE_CONFIGURATION: 'customer-portal-invite-configuration',
    SETTINGS_CUSTOMER_PORTAL_CLIENT_NOTIFICATIONS: 'client-notification',
    SETTINGS_CUSTOMER_PORTAL_PROJECT_TABS: 'project-tabs',
    SETTINGS_HOLIDAY_CALENDAR: 'holiday-calendar',
    SETTINGS_ORGANISATION_CALENDAR: 'organisation-calendar',
    SETTINGS_OUT_OF_OFFICE: 'out-of-office',
    SETTINGS_BILLING: 'billing',
    SETTINGS_TEAM_MEMBERS: 'team-members',
    SETTINGS_NITRO_CREDIT_CONSUMPTION: 'nitro-credit-consumption',
    SETTINGS_SKILL_MATRIX: 'skill-matrix',
    SETTINGS_GROUPS: 'groups',
    SETTINGS_GROUP_ID: ':groupId',
    SETTINGS_GROUP_DETAILS_ADD_MEMBERS: 'add-members',
    SETTINGS_GROUP_DETAILS_REMOVE_MEMBERS: 'remove-members',
    SETTINGS_GROUP_DETAILS_ADD_BULK_MEMBERS: 'add-bulk-members',
    SETTINGS_GROUP_DETAILS_REMOVE_BULK_MEMBERS: 'remove-bulk-members',
    SETTINGS_GROUP_DETAILS: ':groupId/details',
    SETTINGS_ROLES: 'roles',
    SETTINGS_ROLE_ID: ':roleId',
    SETTINGS_PERMISSIONS: 'permissions',
    SETTINGS_NEW_PERMISSION_SET: ':permissionLevel/new',
    SETTINGS_EDIT_PERMISSION_SET: ':permissionLevel/:permissionId/edit',
    SETTINGS_PARTNERS: 'partners',
    SETTINGS_INTEGRATIONS: 'integrations',
    SETTINGS_TIMESHEETS: 'timesheets',
    SETTINGS_TIMESHEETS_POLICIES: 'policies',
    SETTINGS_TIMESHEETS_POLICIES_FLAG_FOR_REVIEW: 'flag-for-review',
    SETTINGS_TIMESHEETS_POLICIES_BLOCK_CREATION: 'block-creation',
    SETTINGS_TIMESHEETS_POLICIES_BLOCK_SUBMISSION: 'block-submission',
    SETTINGS_RESOURCE_MANAGEMENT: 'resource-management',
    SETTINGS_EXPENSE_MANAGEMENT: 'expenses',
    SETTINGS_FINANCIALS: 'financials',
    SETTINGS_REVENUE: 'revenue-entries',
    POSTING_PERIODS: 'posting-periods',
    REVENUE_ESSENTIALS: 'revenue-essentials',
    SETTINGS_CURRENCY: 'currency',
    SETTINGS_RATE_CARDS: 'rate-cards',
    SETTINGS_SPRINT_PLANNING: 'sprint-planning',
    SETTINGS_SPRINT_FIELDS: 'sprint-fields',
    SETTINGS_EPIC_FIELDS: 'epic-fields',
    SETTINGS_PROJECT_FIELDS: 'project-fields',
    SETTINGS_TASK_FIELDS: 'task-fields',
    SETTINGS_TEAM_MEMBER_FIELDS: 'team-member-fields',
    SETTINGS_TIME_ENTRY_FIELDS: 'time-entry-fields',
    SETTINGS_EXPENSE_FIELDS: 'expense-fields',
    SETTINGS_ALLOCATION_FIELDS: 'allocation-fields',
    SETTINGS_INVOICE_CREDIT_NOTES_CUSTOM_FIELDS: 'invoice-credit-notes-custom-fields',
    SETTINGS_COMPANY_FIELDS: 'company-fields',
    SETTINGS_BUDGET_FIELDS: 'budget-fields',
    SETTINGS_CUSTOMER_TEAM_MEMBER_FIELDS: 'customer-team-member-fields',
    SETTINGS_SKILL_FIELDS: 'skill-fields',
    SETTINGS_SKILL_FIELD_ID: ':fieldId',
    SETTINGS_CUSTOM_DOMAIN: 'custom-domain',
    SETTINGS_EMAIL_CONFIGURATION: 'email-configuration',
    SETTINGS_SECURITY: 'security',
    SETTINGS_SCIM: 'scim',
    SETTINGS_API: 'api',
    SETTINGS_WEBHOOK: 'webhook',
    SETTINGS_VAULT: 'vault',
    SETTINGS_KEY_EVENT_AND_INTERVALS: 'keyevents-and-intervals',
    SETTINGS_KEY_EVENTS: 'events',
    SETTINGS_KEY_EVENT_ID: ':eventId',
    SETTINGS_INTERVALS: 'intervals',
    SETTINGS_INTERVAL_ID: ':intervalId',
    SETTINGS_AUTOMATIONS: 'automations',
    SETTINGS_ADVANCED: 'advanced',
    SETTINGS_INTEGRATION_ID: ':integrationId',
    SETTINGS_JIRA_INTEGRATION: 'jira',
    SETTINGS_ZAPIER_INTEGRATION: 'zapier',
    SETTINGS_WORKATO_INTEGRATION: 'workato',
    SETTINGS_SALESFORCE_INTEGRATION: 'salesforce',
    SETTINGS_SALESFORCE_RESOURCE_MAPPINGS: 'resource-mappings',
    SETTINGS_SALESFORCE_ERROR_LOGS: 'error-logs',
    SETTINGS_SLACK_INTEGRATION: 'slack',
    SETTINGS_HUBSPOT_INTEGRATION: 'hubspot',
    SETTINGS_ARCHIVED_PROJECTS: 'archived-projects',
    SETTINGS_AI_FILLS: 'ai-fills',
    SETTINGS_MEETING_INTELLIGENCE_SETUP: 'setup-and-recording',
    SETTINGS_MEETING_INTELLIGENCE_MEETING_SIGNALS: 'meeting-signals',
    SETTINGS_EMAIL_INTELLIGENCE: 'email-intelligence',
    SETTINGS_EMAIL_SETTINGS: 'email-settings',
    SETTINGS_BLACKLISTED_DOMAINS: 'blacklisted-domains',
    SETTINGS_KNOWLEDGE_BASE: 'knowledge-base',
    KNOWLEDGE_BASE_FOLDER: 'folders/:folderId',
    SETTINGS_LANGUAGE_CONFIGURATIONS: 'language-configurations',
    AI_ANALYTICS: 'ai-analytics',
    SIGNALS_AI_ANALYTICS: 'signals-ai-analytics',
    INVOICES: 'invoices',
    INDIVIDUAL_INVOICE_EMAIL_ID: 'emails/:invoiceEmailId',
    INDIVIDUAL_CREDIT_NOTE_EMAIL_ID: 'emails/:creditNoteEmailId',
    INVOICE: 'invoice',
    CREDIT_NOTES: 'credit-notes',
    CREDIT_NOTE_ID: ':creditNoteId',
    TAXES: 'taxes',
    TAXES_CODES: 'codes',
    TAXES_CODES_CODE: 'code',
    TAXES_CODES_COMPONENT: 'component',
    ESSENTIALS: 'essentials',
    APPROVALS: 'approvals',
    CUSTOM_FIELDS: 'custom-fields',
    ADDRESS: 'address',
    CHAIN: 'chain',
    WORKFLOW: 'workflow',
    REVENUE_RECOGNITION: 'revenue-recognition',
    SETTINGS_CUSTOM_APPS: 'custom-apps',
    AGENT_BUILDER: 'agent-builder',
    TIMESHEET_GOVERNANCE: 'timesheet-governance',
    SKILL_BUILDER: 'skills',
    NITRO_BREW: 'nitro-brew',
    SIGNAL_AGENTS: 'signal-agents',
    EXPENSES: 'expenses',
    MY_EXPENSES: 'my-expenses',
    MY_EXPENSE_REPORTS: 'my-expense-reports',
    EXPENSE_APPROVALS: 'approvals',
    SHEETS: 'sheets',
    SHEETS_OPEN: '/sheets/:id',
    SHEETS_OPEN_TABS: '/sheets/:id/tab/:selectedTabId',
    SHEETS_OPEN_PIVOT: '/sheets/:id/pivot/:pivotId',
    SHEETS_OPEN_OVERVIEW: '/sheets/:id/overview',
    SHEETS_OPEN_FIELDS: '/sheets/:id/fields',
    EXPENSE_APPROVAL_REPORTS: 'approval-reports',
    EXPENSE_REPORT_ID: ':expenseReportId',
    GOVERNANCE_POLICIES: 'project-governance',
    PROJECT: 'project',
    PHASE: 'phase',
    TASK: 'task',
    POLICY_TYPE: ':policyType',
    POLICY_ID: ':policyId',
    CONVERSATION_ID: ':conversationId',
    GOVERNANCE_POLICIES_WARN: 'warn',
    GOVERNANCE_POLICIES_BLOCK: 'block',
    REVENUE_ENTRIES: 'revenue-entries',
    REVENUE_ENTRIES_OVERVIEW: 'overview',
    REVENUE_ENTRIES_ALL: 'list'
};
export const RouteIds = {
    projectDetailRoute: 'project-detail-route'
};
